<template>
  <transition enter-active-class="fadeIn"
              leave-active-class="fadeOut">
    <div v-show="show"
         id="back-top"
         class="theme-bg-primary-color"
         @click="scrollStart"><Icon type="md-arrow-up" size="25"/></div>
  </transition>
</template>
<script>
export default {
  name: 'backTop',
  data() {
    return {
      el: null,
      show: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.el = this.$el.parentNode
      this.el.onscroll = () => {
        if (this.el.scrollTop > 400) {
          this.show = true
        } else {
          this.show = false
        }
      }
    })
  },
  methods: {
    scrollStart() {
      this.scrollTop(this.el, this.el.scrollTop, 0)
    },
    // scrollTop animation
    scrollTop: (el, from = 0, to, duration = 500, endCallback) => {
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame =
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          function(callback) {
            return window.setTimeout(callback, 1000 / 60)
          }
      }
      const difference = Math.abs(from - to)
      const step = Math.ceil((difference / duration) * 50)

      function scroll(start, end, step) {
        if (start === end) {
          endCallback && endCallback()
          return
        }

        let d = start + step > end ? end : start + step
        if (start > end) {
          d = start - step < end ? end : start - step
        }

        if (el === window) {
          window.scrollTo(d, d)
        } else {
          el.scrollTop = d
        }
        window.requestAnimationFrame(() => scroll(d, end, step))
      }
      scroll(from, to, step)
    }
  }
}
</script>
<style lang="stylus" scoped>
#back-top
  position fixed
  width 50px
  height 50px
  line-height 50px
  text-align center
  color #fff
  bottom 40px
  right 60px
  border-radius 50%
  z-index 999
  cursor pointer

@keyframes fadeIn
  from
    opacity 0

  to
    opacity 1

@keyframes fadeOut
  from
    opacity 1

  to
    opacity 0

.fadeIn
  animation fadeIn 0.5s

.fadeOut
  animation fadeOut 0.5s
</style>
